<template>
  <div>
    <PieChart
      v-if="renderFlag"
      :options="options"
      :chart-data="chartDataProcessed"
    ></PieChart>
  </div>
</template>

<script>
import PieChart from "@/components/panel/charts/PieChart.vue";

export default {
  components: {
    PieChart
  },
  props: {
    simposiums: {
      type: Array
    }
  },
  mounted() {
    this.fillData();
  },
  watch: {
    simposiums() {
      this.fillData();
    }
  },
  data() {
    return {
      renderFlag: false,
      chartDataProcessed: {
        labels: [],
        datasets: [
          {
            borderWidth: 1,
            borderColor: [],
            backgroundColor: [],
            data: []
          }
        ]
      },
      options: {
        legend: {
          display: true
        },
        responsive: true,
        maintainAspectRatio: false
      }
    };
  },
  methods: {
    fillData() {
      var context = this;
      context.renderFlag = false;
      context.chartDataProcessed.labels = [];
      context.chartDataProcessed.datasets[0].borderColor = [];
      context.chartDataProcessed.datasets[0].backgroundColor = [];
      context.chartDataProcessed.datasets[0].data = [];
      console.log("context.chartDataProcessed");
      console.log(context.chartDataProcessed);
      this.simposiums.forEach(element => {
        console.log("entra");
        context.renderFlag = false;
        context.chartDataProcessed.labels.push(element.acronym);
        context.chartDataProcessed.datasets[0].borderColor.push(element.color);
        context.chartDataProcessed.datasets[0].backgroundColor.push(
          element.color
        );
        context.chartDataProcessed.datasets[0].data.push(element.total);
        context.renderFlag = true;
      });
      console.log("context.chartDataProcessed");
      console.log(context.chartDataProcessed);
    }
  }
};
</script>
